import Phaser from 'phaser';
import { CANVAS_W, CANVAS_H } from '../types';
import { loadNames, saveNames } from '../systems/SaveManager';

export class NameInputScene extends Phaser.Scene {
  private p1 = 'GEO';
  private p2 = 'ARIS';
  private active: 'p1' | 'p2' = 'p1';
  private p1Text!: Phaser.GameObjects.Text;
  private p2Text!: Phaser.GameObjects.Text;

  constructor() { super({ key: 'NameInputScene' }); }

  create() {
    this.cameras.main.setBackgroundColor('#131120');
    const names = loadNames();
    this.p1 = names.p1;
    this.p2 = names.p2;

    this.add.text(CANVAS_W / 2, 80, 'NUME JUCĂTORI', {
      fontFamily: 'monospace', fontSize: '32px', color: '#ffd166',
    }).setOrigin(0.5);

    this.add.text(CANVAS_W / 2, 140,
      'Click pe un nume sau Tab/Săgeți să schimbi, A-Z să tastezi, BACKSPACE șterge',
      { fontFamily: 'monospace', fontSize: '12px', color: '#888' }
    ).setOrigin(0.5);

    this.add.text(CANVAS_W / 2 - 160, 220, 'P1 (Geo, roșu)', {
      fontFamily: 'monospace', fontSize: '18px', color: '#e63946',
    }).setOrigin(0.5);
    this.p1Text = this.add.text(CANVAS_W / 2 - 160, 270, '', {
      fontFamily: 'monospace', fontSize: '40px',
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });
    this.p1Text.on('pointerdown', () => { this.active = 'p1'; this.redraw(); });

    this.add.text(CANVAS_W / 2 + 160, 220, 'P2 (Aris, verde)', {
      fontFamily: 'monospace', fontSize: '18px', color: '#52b788',
    }).setOrigin(0.5);
    this.p2Text = this.add.text(CANVAS_W / 2 + 160, 270, '', {
      fontFamily: 'monospace', fontSize: '40px',
    }).setOrigin(0.5).setInteractive({ useHandCursor: true });
    this.p2Text.on('pointerdown', () => { this.active = 'p2'; this.redraw(); });

    const saveBtn = this.add.text(CANVAS_W / 2, CANVAS_H - 140,
      '✓ SALVEAZĂ ȘI ÎNAPOI (Enter)',
      { fontFamily: 'monospace', fontSize: '20px', color: '#06d6a0' }
    ).setOrigin(0.5).setInteractive({ useHandCursor: true });
    saveBtn.on('pointerdown', () => this.commit());

    this.add.text(CANVAS_W / 2, CANVAS_H - 80,
      'ESC = înapoi fără salvare',
      { fontFamily: 'monospace', fontSize: '14px', color: '#888' }
    ).setOrigin(0.5);

    this.redraw();

    const kb = this.input.keyboard!;
    kb.on('keydown', (ev: KeyboardEvent) => this.onKey(ev));
  }

  private onKey(ev: KeyboardEvent) {
    if (ev.key === 'Enter') { this.commit(); return; }
    if (ev.key === 'Escape') { this.scene.start('MenuScene'); return; }
    if (ev.key === 'Tab' || ev.key === 'ArrowLeft' || ev.key === 'ArrowRight') {
      ev.preventDefault?.();
      this.active = this.active === 'p1' ? 'p2' : 'p1';
      this.redraw();
      return;
    }
    if (ev.key === 'Backspace') {
      if (this.active === 'p1') this.p1 = this.p1.slice(0, -1);
      else                       this.p2 = this.p2.slice(0, -1);
      this.redraw();
      return;
    }
    // Letters/digits only, max 8
    if (/^[a-zA-Z0-9]$/.test(ev.key)) {
      const ch = ev.key.toUpperCase();
      if (this.active === 'p1' && this.p1.length < 8) this.p1 += ch;
      if (this.active === 'p2' && this.p2.length < 8) this.p2 += ch;
      this.redraw();
    }
  }

  private redraw() {
    const p1Hi = this.active === 'p1';
    const p2Hi = this.active === 'p2';
    this.p1Text.setText(`[${this.p1 || '_'}${'_'.repeat(Math.max(0, 8 - this.p1.length))}]`);
    this.p2Text.setText(`[${this.p2 || '_'}${'_'.repeat(Math.max(0, 8 - this.p2.length))}]`);
    this.p1Text.setColor(p1Hi ? '#ffd166' : '#fff');
    this.p2Text.setColor(p2Hi ? '#ffd166' : '#fff');
  }

  private commit() {
    const p1 = this.p1.trim() || 'GEO';
    const p2 = this.p2.trim() || 'ARIS';
    saveNames({ p1, p2 });
    this.scene.start('MenuScene');
  }
}
